module.exports = __webpack_public_path__ + "img/273-4aa849.png";